<template>
	<div id="app">
		<div class="mb-5" v-if="this.foundStudent==false">
			<banner></banner>
		</div>

		<div class="container">
		
			<div class="row" >
				<div class="col-md-3 " >
					<div class="pr-3 pl-3" >


						<!-- Quick Nav: <ul>
							<li v-for="(item, index) in teamData">
								<router-link :to="'/categories/'+index">{{ index }}</router-link>
							</li>
						</ul>  -->

						<!-- <router-view></router-view> -->

				
						<!-- {{ $route.params.id}} -->

						<!-- <div class="py-2 pl-1 font-weight-bold" >Refine your search</div> -->
						<div class="row">
							<location-box ref="locationBox" :location-data="locationData"></location-box>
						</div>
						<!-- <hr v-bind:class="{ 'd-none': foundStudentNoJobs }"> -->
						
						<div class="row" v-bind:class="{ 'd-none': foundStudentNoJobs }">
							<team-box ref="teamBox" :team-data="teamData"></team-box>
						</div>

						<div class="row" v-bind:class="{ 'd-none': foundStudentNoJobs }">
							<commitment-box ref="commitmentBox" :commitment-data="commitmentData"></commitment-box>
						</div>
					</div>

				</div>

				<div class="col-md-9" >



						<!-- <h2 class="text-center">Jobs</h2>  -->
							<div v-for="item in filterLabels" class="btn btn-secondary mr-2 mb-3" >
								{{ item }} <a href="#" @click="resetSingleCheckboxFilter(item)" class="pl-2 text-white">X</a>
							</div> 
							<span v-if="filterLabels.length>=1" class="clear-link" @click="resetCheckboxFilters()" >Clear All</span>

							
						<form @submit.prevent v-bind:class="{ 'd-none': foundStudentNoJobs }" class="mb-4">
							<div class="input-group">
									<input class="form-control col-md-5 mb-2" type="text" placeholder="Search from below list" v-model.trim="search" v-on:keyup.enter.prevent="getFilteredJobs" >
									<div class="col-md-5 offset-md-2 mb-1">
										<div class="input-group">
											<label for="sort" class="pr-3 pt-1 sort-text"><span class="text-center uppercase" v-if="!loading && jobAmount!=0">{{ title }} |</b></span> Sort by</label>
											<!-- <select v-model="sortSelected" id="sort" @change="getFilteredJobs($event)"> -->
											<select v-model="sortSelected" id="sort" class="form-control">
												<option v-for="option in options" v-bind:value="option.value">
													{{ option.text }}
												</option>
											</select>
										</div>
									</div>
									<!-- <span>Selected: {{ selected }}</span> -->

							</div>


						</form>

					<!-- <h5 class="text-center uppercase" v-if="!loading && jobAmount!=0">{{ title }}</b></h5> -->
					<div v-if="loading" class="loader"><img src="https://cdnjs.cloudflare.com/ajax/libs/semantic-ui/0.16.1/images/loader-large.gif" alt="loader"></div>
						
					<job-list v-if="jobAmount!=0" :jobs="jobs"  :filteredjobs="filteredjobs" :sort-selected="sortSelected" ></job-list>

					<div v-if="jobAmount!=0" class="jobAmount pb-2">1 - {{jobAmount}} of {{jobAmount}} jobs</div> 

					<div v-if="jobAmount==0" class="text-center py-4 border">
						<img src="https://careers.pointclickcare.com/wp-content/uploads/2019/04/no_jobs_found.png" alt="No jobs found.">
						<div class="no-jobs">There are no jobs for your search criteria.</div>
					</div>
						

				</div>
			</div>
		</div>
	</div>
</template>

<script>
import Banner from "./components/Banner.vue";
import LocationBox from "./components/LocationBox.vue";
import CommitmentBox from "./components/CommitmentBox.vue";
import TeamBox from "./components/TeamBox.vue";
import JobList from "./components/JobList.vue";
import { EventBus } from './event-bus.js';


// EventBus.$on('checkedLocationIDstore', checkedNames => {
//   console.log(`Oh, that's nice. It's gotten ${checkedNames} clicks! :)`)
// });



export default {
  name: 'app',
  components: {
    Banner, LocationBox, CommitmentBox, TeamBox, JobList
  },
  data() {
    return {
        jobs: [],
        filteredjobs: [],
        locationData: [],
        teamData: [],
        commitmentData: [],
        filterLabels:[],
        checkedLocationIDstore:[],
        checkedTeamIDstore : [],
        checkedCommitmentIDstore : [],
        foundStudentNoJobs: false,
        foundStudent: false,
        search: '',
        loading: true,
        PccUrl: "https://api.lever.co/v0/postings/pointclickcare",
        title: '',
        jobAmount:0,
        relatedJobs: [],
        sortSelected: 'A',
        options: [{ text: 'Most recent', value: 'A' }]
    }
  },
  metaInfo: {
    // if no subcomponents specify a metaInfo.title, this title will be used
    title: 'PointClickCare Jobs',
    // all titles will be injected into this template
    titleTemplate: '%s | Careers',
     meta: [
      { charset: 'utf-8' },
      { name: 'description', content: 'All jobs' }
    ]
  },
  created () {
    this.getPosts();
    if(typeof isStudent !== 'undefined'){
      this.foundStudent = true;
      // console.log('this.foundStudent');
      if(this.jobAmount==0){
        this.foundStudentNoJobs = true;
        
      }
    };
    // console.log(this.$router.options.routes);
  },
  mounted () {
    EventBus.$on('checkedLocationIDstore', checkedNames => {
        // console.log(`Oh, that's nice. It's gotten ${checkedNames} clicks! :)`);
        this.checkedLocationIDstore = checkedNames;
        // console.log(`checkedLocationIDstore ${this.checkedLocationIDstore} clicks! :)`);
        this.getFilteredJobs();
    });
    EventBus.$on('checkedTeamIDstore', checkedNames => {
        // console.log(`Oh, that's nice. It's gotten ${checkedNames} clicks! :)`);
        this.checkedTeamIDstore = checkedNames;
        // console.log(`checkedTeamIDstore ${this.checkedTeamIDstore} clicks! :)`);
        this.getFilteredJobs();
    });
    EventBus.$on('checkedCommitmentIDstore', checkedNames => {
        // console.log(`Oh, that's nice. It's gotten ${checkedNames} clicks! :)`);
        this.checkedCommitmentIDstore = checkedNames;
        // console.log(`checkedCommitmentIDstore ${this.checkedCommitmentIDstore} clicks! :)`);
        this.getFilteredJobs();
    });

  },
  methods: {
    getPosts() {
      var url = this.buildUrl();
      // console.log("Intial Job URL: "+url);
      this.axios.get(url).then((response) => {
        this.loading = false;
        this.jobs = response.data;
        // console.log(this.jobs);

        // -------------

        //
        // var locationArray = [], la = response.data.length, a, lcount=0;
        // for( a=0; a<la; a++) {
        //   if(locationArray[response.data[a].categories.location]) continue;

        //   locationArray[response.data[a].categories.location] = true;
        //   locationArray.push(response.data[a].categories.location);
        // }
        // console.log(locationArray);
                //     locationCounter[key] = (locationCounter[key] || 0) + 1
        // })
        // console.log('locationCounter');
        // console.log(locationCounter);
        // this.locationData = locationCounter;

        this.getFilteredLocations(this.jobs);
        this.getFilteredTeams(this.jobs);
        this.getFilteredcCommitments(this.jobs);    


        // var teamArray = [], la = response.data.length, a;
        // for( a=0; a<la; a++) {
        //   if(teamArray[response.data[a].categories.team]) continue;
        //   teamArray[response.data[a].categories.team] = true;
        //   teamArray.push(response.data[a].categories.team);
        // }
        // console.log(teamArray);
        // this.teamData = teamArray

        // var teamCounter = {};
        // response.data.forEach(function(obj) {
        //     var key = obj.categories.team;
        //     teamCounter[key] = (teamCounter[key] || 0) + 1
        // })
        // console.log('teamCounter');
        // console.log(teamCounter);
        // this.teamData = teamCounter;

        // var commitmentArray = [], la = response.data.length, a;
        // for( a=0; a<la; a++) {
        //   if(commitmentArray[response.data[a].categories.commitment]) continue;
        //   commitmentArray[response.data[a].categories.commitment] = true;
        //   commitmentArray.push(response.data[a].categories.commitment);
        // }
        // console.log(commitmentArray);
        // this.commitmentData = commitmentArray

        // var commitmentCounter = {};
        // response.data.forEach(function(obj) {
        //     var key = obj.categories.commitment;
        //     commitmentCounter[key] = (commitmentCounter[key] || 0) + 1
        // })
        // console.log('commitmentCounter');
        // console.log(commitmentCounter);
        // this.commitmentData = commitmentCounter;

        // console.log(this.jobs);

        this.jobAmount = response.data.length;

      //console.log(this.checkedNames);

        //var title = this.location_id !== '156' ? "Top jobs in '"+ this.location_id + "' today " : "Top jobs today ";
        this.title = this.jobAmount+ " Jobs";
        //
        if(this.$route.params.keywords) {
          // console.log(this.$route.params.keywords);
          this.search = this.$route.params.keywords;
          this.getFilteredJobs();
        }
    

      }).catch((error) => { console.log(error); });

    },
    buildUrl() {
        if(typeof isStudent !== 'undefined'){
            this.PccUrl = this.PccUrl+ "?"+"commitment=Internship"+"&"+"commitment=Student" +"&mode=json";
            // console.log(PccUrl);
        } else {
            this.PccUrl = this.PccUrl+ "?"+"mode=json";
        }
        return this.PccUrl;
    },
    convertToSlug(Text) {
      if(Text){
        return Text.toLowerCase().replace(/[^\w ]+/g,'').replace(/ +/g,'-');
      }
    },
    resetCheckboxFilters() {
      // console.log("Reset");

      this.search = '';
      //reset return data with no filters
        //   this.getFilteredJobs();
 
      //call function on child to reset checkboxes
      this.filterLabels = [];
      this.$refs.locationBox.uncheckBoxes();
      this.$refs.teamBox.uncheckBoxes();
      this.$refs.commitmentBox.uncheckBoxes();
    },
    resetSingleCheckboxFilter(box) {
      if(box){
        // console.log(box);
        this.$refs.locationBox.uncheckBox(box);
        this.$refs.teamBox.uncheckBox(box);
        this.$refs.commitmentBox.uncheckBox(box);
      }
    },
    getFilteredLocations(jbs) {
      var locationCounter = {};
      jbs.forEach(function(obj) {
          var key = obj.categories.location;
          if(typeof key !== "undefined"){
            locationCounter[key] = (locationCounter[key] || 0) + 1
          }
      })
      // console.log('locationCounter');
      // console.log(locationCounter);
      this.locationData = locationCounter;
    },
    getFilteredTeams(jbs) {
      var teamCounter = {};
      jbs.forEach(function(obj) {
          var key = obj.categories.team;
          if(typeof key !== "undefined"){
            teamCounter[key] = (teamCounter[key] || 0) + 1
          }
      })
      // console.log('teamCounter');
      // console.log(teamCounter);
      this.teamData = teamCounter;
    },
    getFilteredcCommitments(jbs) {
      var commitmentCounter = {};
      jbs.forEach(function(obj) {
        var key = obj.categories.commitment;
        if(typeof key !== "undefined"){
          commitmentCounter[key] = (commitmentCounter[key] || 0) + 1
        }

      })
      // console.log('commitmentCounter');
      // console.log(commitmentCounter);
      this.commitmentData = commitmentCounter;
    },
    getFilteredJobs() {
      
      // console.log('getFilteredJobs');

      // console.log(checkedTeamIDstore);



      // search by full words
      if (this.search !== '') {
      // if (this.search !== '' && this.search.length>=3) {
        this.filteredjobs = this.jobs.filter(obj => this.search.toLowerCase().split(' ').every(v => obj.text.toLowerCase().includes(v)));
      } else {
        this.filteredjobs = this.jobs;
      }

      // console.log(checkedLocationIDstore.length);
      // this.filteredjobs = this.jobs.filter(position => checkedLocationIDstore.includes(position.categories.location));
      // this.filteredjobs = this.jobs.filter(position => checkedTeamIDstore.includes(position.categories.team));
      // this.filteredjobs = this.jobs.filter(position => checkedCommitmentIDstore.includes(position.categories.commitment));


      // if(checkedLocationIDstore.length>=1 || checkedTeamIDstore.length>=1 || this.checkedCommitmentIDstore.length>=1){
        if(this.checkedLocationIDstore && this.checkedLocationIDstore.length>=1){
          // filtering results using checkboxes
          this.filteredjobs = this.jobs.filter(position => this.checkedLocationIDstore.includes(position.categories.location));

          if(this.checkedLocationIDstore.length>=1 && this.checkedTeamIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
            this.filteredjobs = this.filteredjobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
            this.filteredjobs = this.filteredjobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
          } else if(this.checkedLocationIDstore.length>=1 && this.checkedTeamIDstore.length>=1){
            this.filteredjobs = this.filteredjobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
            this.getFilteredcCommitments(this.filteredjobs);
          } else if(this.checkedLocationIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
              this.filteredjobs = this.filteredjobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
              this.getFilteredTeams(this.filteredjobs);
              // console.log(this.getFilteredTeams(this.filteredjobs));
          } else {
            this.getFilteredTeams(this.filteredjobs);
            this.getFilteredcCommitments(this.filteredjobs);
          }
        } else if(this.checkedTeamIDstore && this.checkedTeamIDstore.length>=1){
          // filtering results using checkboxes
          this.filteredjobs = this.jobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
          // console.log(this.jobs);
            if(this.checkedTeamIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
              
              this.filteredjobs = this.filteredjobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
              this.getFilteredLocations(this.filteredjobs);
            } else {
            this.getFilteredLocations(this.filteredjobs);
            this.getFilteredcCommitments(this.filteredjobs);
          }
        } else if(this.checkedCommitmentIDstore && this.checkedCommitmentIDstore.length>=1){
          // filtering results using checkboxes
          this.filteredjobs = this.jobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
            if(this.checkedTeamIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
              this.filteredjobs = this.filteredjobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
              this.getFilteredLocations(this.filteredjobs);
            } else {
              this.getFilteredLocations(this.filteredjobs);
              this.getFilteredTeams(this.filteredjobs);
            }
        }

        // get checked box labels

        if((this.checkedLocationIDstore) && (this.checkedTeamIDstore) && (this.checkedCommitmentIDstore)){

          //reset array
          this.filterLabels = [];
          // combine artays
          this.filterLabels = this.checkedLocationIDstore.concat(this.checkedTeamIDstore,this.checkedCommitmentIDstore);
          // console.log(this.filterLabels);
          // typeof(this.filterLabels);
        }

        // console.log(this.checkedLocationIDstore,this.checkedTeamIDstore,this.checkedCommitmentIDstore);
        
        // if(this.checkedLocationIDstore.length>=1 && this.checkedTeamIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
        //   this.filteredjobs = this.filteredjobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
        //   this.filteredjobs = this.filteredjobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
        // } else {
        //   if(this.checkedLocationIDstore.length>=1 && this.checkedTeamIDstore.length>=1){
        //     this.filteredjobs = this.filteredjobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
        //     this.getFilteredcCommitments(this.filteredjobs);
        //   }
        //   if(this.checkedLocationIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
        //     this.filteredjobs = this.filteredjobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
        //     this.getFilteredTeams(this.filteredjobs);
        //   }
        //   if(this.checkedTeamIDstore.length>=1 && this.checkedCommitmentIDstore.length>=1){
        //     this.filteredjobs = this.filteredjobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
        //     this.getFilteredLocations(this.filteredjobs);
        //   }
        // }


      // if(this.checkedLocationIDstore.length>=1 || this.checkedTeamIDstore.length>=1 || this.checkedCommitmentIDstore.length>=1){
      // if(this.checkedLocationIDstore && this.checkedLocationIDstore.length>=1){
      //   // filtering results using checkboxes
      //   this.filteredjobs = this.jobs.filter(position => this.checkedLocationIDstore.includes(position.categories.location));

      //   this.getFilteredTeams(this.filteredjobs);
      //   this.getFilteredcCommitments(this.filteredjobs);

      //   if(this.checkedTeamIDstore && this.checkedTeamIDstore.length>=1){
      //     this.filteredjobs = this.jobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
      //   }
      //   if(this.checkedCommitmentIDstore && this.checkedCommitmentIDstore.length>=1){
      //     this.filteredjobs = this.jobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
      //   }
      // }
      // if(this.checkedTeamIDstore && this.checkedTeamIDstore.length>=1){
      //   // filtering results using checkboxes
      //   this.filteredjobs = this.jobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
      //   this.getFilteredLocations(this.filteredjobs);
      //   this.getFilteredTeams(this.filteredjobs);

      //   if(this.checkedLocationIDstore && this.checkedLocationIDstore.length>=1){
      //     this.filteredjobs = this.jobs.filter(position => this.checkedLocationIDstore.includes(position.categories.location));
      //   }
      //   if(this.checkedCommitmentIDstore && this.checkedCommitmentIDstore.length>=1){
      //     this.filteredjobs = this.jobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
      //   }
      // }
      // if(this.checkedCommitmentIDstore && this.checkedCommitmentIDstore.length>=1){
      //   // filtering results using checkboxes
      //   this.filteredjobs = this.jobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
      //   this.getFilteredLocations(this.filteredjobs);
      //   this.getFilteredTeams(this.filteredjobs);  

      //   if(this.checkedTeamIDstore && this.checkedTeamIDstore.length>=1){
      //     this.filteredjobs = this.jobs.filter(position => this.checkedTeamIDstore.includes(position.categories.team));
      //   }
      //   if(this.checkedCommitmentIDstore && this.checkedCommitmentIDstore.length>=1){
      //     this.filteredjobs = this.jobs.filter(position => this.checkedCommitmentIDstore.includes(position.categories.commitment));
      //   }

      // }

      // this.getFilteredLocations(this.filteredjobs);
      // this.getFilteredTeams(this.filteredjobs);
      // this.getFilteredcCommitments(this.filteredjobs);

      // console.log(this.filteredjobs);
      // console.log(this.filteredjobs.length);
      this.jobAmount = this.filteredjobs.length;
      if(this.jobAmount == 0){
        // console.log("no filtered results");

      }

      // if((this.checkedLocationIDstore & this.checkedLocationIDstore.length==0) && (this.checkedTeamIDstore & this.checkedTeamIDstore.length==0) && (this.checkedCommitmentIDstore & this.checkedCommitmentIDstore.length==0)){
      if((this.checkedLocationIDstore === undefined || this.checkedLocationIDstore.length == 0) && (this.checkedTeamIDstore === undefined || this.checkedTeamIDstore.length == 0) && (this.checkedCommitmentIDstore === undefined || this.checkedCommitmentIDstore.length == 0) && (this.search==='')){
        // console.log("filters empty");
        this.jobAmount = this.jobs.length;
        this.getFilteredLocations(this.jobs);
        this.getFilteredTeams(this.jobs);
        this.getFilteredcCommitments(this.jobs);        
      }
      this.title = this.jobAmount+ " Jobs";


    }
  }
}
</script>



<style>

#app{
    font-family: 'Roboto', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;  
}

#app fieldset {
    display: inline-block;
    border-bottom: 1px solid #e6e6e6;
    padding: 1rem 1rem 0px 0rem;
    margin-bottom: 20px;
}

#app legend {
    /* background-color: #e6e6e6; */
    padding: 0rem;
    margin: 0;
}
#app .btn{
    border-radius: 0;
}
#app .form-control{
    border-radius:0;
}
#app .output {
    font: 1rem arial, sans-serif;
}
.clear-link{
    border-bottom: 1px dotted #333333;
    cursor: pointer;
}
#app input[type=checkbox] {
    margin: 0px 5px 0 0;
    vertical-align: middle;
    position: relative;
    top: -3px;
}
#app .sort-text{
    font-size: 14px;
}
#app .card{
    border-radius: 0;
    border: none;
    border-bottom: 1px solid rgba(0,0,0,.125);
}

#app .card .card-header{
    background-color: #fff;
    border: none;
    font-size: 21px;
    padding-bottom: 0;
    padding-left: 0;
}
#app .card .card-body{
    padding-top: 8px;
    padding-left: 0;
}
#app .card a{
    color: #424242
}
#app .card p{
    font-size: 14px;
}

#app .jobAmount{
    font-size: 14px;
}
#app .type-info{
    color: #7c7c7c;
}
#app label{
	cursor: pointer;
}
#app label span{
    display: inline-block;
    padding-top: 5px;
}
#app .green{
	color: green;
}

#app .red{
	color: red;
}

/* Toggles */
#app fieldset{
    display: block;
    width: 100%
}
#app .panel-title a{
   color: #424242;
   display: block;
}
#app .panel-title {
    font-size: 16px;
}
#app .panel-title > a:before {
    float: right !important;
    font-family: FontAwesome;
    content:"-";
    padding-right: 5px;
    font-size: 20px;
}
#app .panel-title > a.collapsed:before {
    float: right !important;
    content:"+";
}
#app .collapse{
    /* border-top: 1px solid #e6e6e6; */
    /* padding: 15px 0; */
}
.input-list:first-child{
    border-top: 1px solid #e6e6e6;
    padding-top: 15px;
}
.input-list:last-child{
    padding-bottom: 15px;
}
#app .panel-title > a:hover, 
#app .panel-title > a:active, 
#app .panel-title > a:focus  {
    text-decoration:none;
}
/* For mobile */
@media (max-width: 992px) { 
    #app .jumbotron{
        text-align: center;
        background-image: none !important;
    }
    #app .jumbotron h1{
        padding: 0 !important;

    }
    #app .jumbotron .py-5{
        padding: 0px !important;

    }
 }

 #app .no-jobs{
    color: #82bd45;
    font-size: 22px;
 }
/* .carousel-control-next, .carousel-control-prev{
    display: none; 
}
*/
/* .carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23e66216' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
}
.carousel-control-next-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23f00' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
} */
</style>
